module.exports = __webpack_public_path__ + "img/oil-export-white.272be584.png";